import React from "react";
import GenericDialog from "@common/GenericDialog";

const DeleteStepDialog = props => {
    const {open, data, onClose} = props;

    return (
        <GenericDialog
            title="Delete step"
            contentStyle={{
                width: 480
            }}
            open={open}
            onClose={onClose}
            buttons={[
                {
                    name: "Cancel",
                    extraProps: {type: 'text'},
                    callback: async () => {
                        onClose();
                    }
                }, {
                    name: "Delete",
                    callback: async () => {
                        data.onDelete();
                        onClose();
                    }
                }
            ]}
        >
            <div className='padding-x--l padding-y--xl'>
                <p className="ch-center-elem">Are you sure you would like to delete this step?</p>
            </div>
        </GenericDialog>
    )
}

export default DeleteStepDialog;